import { render, staticRenderFns } from "./RowBlockWritingOffCommissionAccident.vue?vue&type=template&id=3b99e658&"
import script from "./RowBlockWritingOffCommissionAccident.vue?vue&type=script&lang=js&"
export * from "./RowBlockWritingOffCommissionAccident.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports